import Vue from 'vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueRouter from 'vue-router'
import store from './store'
import helper from './services/helper'
Vue.use(Loading);

let pageLoader;

let routes = [
    {
        path: '/',                                       // all the routes which needs authentication + two factor authentication + lock screen
        component: require('./layouts/default-page').default,
        meta: { validate: ['auth','two_factor','lock_screen', 'complete_profile'] },
        children: [
            {
                path: '/',
                component: require('./views/pages/home').default
            },
            {
                path: '/home',
                component: require('./views/pages/home').default
            },
            {
                path: '/change-password',
                component: require('./views/pages/change-password').default
            },
            {
                path: '/blank',
                component: require('./views/pages/blank').default
            },
            {
                path: '/calendar',
                component: require('./views/calendar/index').default
            },
            {
                path: '/configuration',
                component: require('./views/configuration/basic/index').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/configuration/logo',
                component: require('./views/configuration/logo/index').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/configuration/mail',
                component: require('./views/configuration/mail/index').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/backup',
                component: require('./views/backup/index').default
            },
            {
                path: '/configuration/basic',
                component: require('./views/configuration/basic/index').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/configuration/system',
                component: require('./views/configuration/system/index').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/configuration/role',
                component: require('./views/configuration/role/index').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/configuration/menu',
                component: require('./views/configuration/menu/index').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/configuration/authentication',
                component: require('./views/configuration/authentication/index').default,
                meta: { menu: 'configuration'}
            },
            // {
            //     path: '/configuration/sms',
            //     component: require('./views/configuration/sms/index').default,
            //     meta: { menu: 'configuration'}
            // },
            {
                path: '/configuration/scheduled-job',
                component: require('./views/configuration/scheduled-job/index').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/configuration/ip-filter',
                component: require('./views/configuration/ip-filter/index').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/configuration/ip-filter/:id/edit',
                component: require('./views/configuration/ip-filter/edit').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/configuration/permission',
                component: require('./views/configuration/permission/index').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/configuration/permission/assign',
                component: require('./views/configuration/permission/assign').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/configuration/locale',
                component: require('./views/configuration/locale/index').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/configuration/locale/:id/edit',
                component: require('./views/configuration/locale/edit').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/configuration/locale/:locale',
                component: require('./views/configuration/locale/view').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/configuration/locale/:locale/:module',
                component: require('./views/configuration/locale/view').default,
                meta: { menu: 'configuration'}
            },
            {
                path: '/email-template',
                component: require('./views/email-template/index').default
            },
            {
                path: '/email-template/:id/edit',
                component: require('./views/email-template/edit').default
            },
            {
                path: '/email-log',
                component: require('./views/email-log/index').default
            },
            {
                path: '/activity-log',
                component: require('./views/activity-log/index').default
            },
            {
                path: '/todo',
                component: require('./views/todo/index').default
            },
            {
                path: '/todo/:id/edit',
                component: require('./views/todo/edit').default
            },
            {
                path: '/user',
                component: require('./views/user/index').default
            },
            {
                path: '/staff',
                component: require('./views/user/staff').default
            },
            {
                path: '/user/:id',
                component: require('./views/user/basic').default
            },
            {
                path: '/user/:id/basic',
                component: require('./views/user/basic').default
            },
            {
                path: '/user/:id/contact',
                component: require('./views/user/contact').default
            },
            {
                path: '/user/:id/avatar',
                component: require('./views/user/avatar').default
            },
            {
                path: '/user/:id/social',
                component: require('./views/user/social').default
            },
            {
                path: '/user/:id/password',
                component: require('./views/user/password').default
            },
            {
                path: '/user/:id/email',
                component: require('./views/user/email').default
            },
            {
                path: '/tax-payer',
                component: require('./views/tax-payer/index').default
            },
            {
                path: '/tax-payer/create',
                component: require('./views/tax-payer/create').default
            },
            {
                path: '/tax-payer/:id/edit',
                component: require('./views/tax-payer/edit').default
            },
            {
                path: '/tax-payer/:id',
                component: require('./views/tax-payer/basic').default
            },
            {
                path: '/tax-payer/:id/basic',
                component: require('./views/tax-payer/basic').default
            },
            {
                path: '/tax-payer/:id/contact',
                component: require('./views/tax-payer/contact').default
            },
            {
                path: '/tax-payer/:id/avatar',
                component: require('./views/tax-payer/avatar').default
            },
            {
                path: '/tax-payer/:id/social',
                component: require('./views/tax-payer/social').default
            },
            {
                path: '/tax-payer/:id/password',
                component: require('./views/tax-payer/password').default
            },
            {
                path: '/tax-payer/:id/email',
                component: require('./views/tax-payer/email').default
            },
            {
                path: '/message',
                component: require('./views/message/index').default
            },
            {
                path: '/message/compose',
                component: require('./views/message/index').default
            },
            {
                path: '/message/inbox',
                component: require('./views/message/inbox').default
            },
            {
                path: '/message/sent',
                component: require('./views/message/sent').default
            },
            {
                path: '/message/important',
                component: require('./views/message/important').default
            },
            {
                path: '/message/trash',
                component: require('./views/message/trash').default
            },
            {
                path: '/message/draft',
                component: require('./views/message/draft').default
            },
            {
                path: '/message/:uuid/draft',
                component: require('./views/message/edit-draft').default
            },
            {
                path: '/message/:uuid',
                component: require('./views/message/view').default
            },
            {
                path: '/annual-return',
                component: require('./views/annual-return/index').default
            },
            {
                path: '/annual-return/create',
                component: require('./views/annual-return/create').default
            },
            {
                path: '/annual-return/:id/edit',
                component: require('./views/annual-return/edit').default
            },
            {
                path: '/annual-return/:id',
                component: require('./views/annual-return/show').default
            },
            {
                path: '/e-filling',
                component: require('./views/e-filling/index').default
            },
            {
                path: '/e-filling/create',
                component: require('./views/e-filling/create').default
            },
            {
                path: '/e-filling/:id/edit',
                component: require('./views/e-filling/edit').default
            },
            {
                path: '/e-filling/:id',
                component: require('./views/e-filling/show').default
            },
            {
                path: '/tcc',
                component: require('./views/tcc/index').default
            },
            {
                path: '/tcc/create',
                component: require('./views/tcc/create').default
            },
            {
                path: '/tcc/:id/edit',
                component: require('./views/tcc/edit').default
            },
            {
                path: '/tcc/:id',
                component: require('./views/tcc/show').default
            },
            {
                path: '/payment',
                component: require('./views/payment/index').default
            },
            {
                path: '/payment/create',
                component: require('./views/payment/create').default
            },
            {
                path: '/payment/:id/edit',
                component: require('./views/payment/edit').default
            },
            {
                path: '/payment/:id',
                component: require('./views/payment/show').default
            },
            {
                path: '/setting/category',
                component: require('./views/setting/category/index').default
            },
            {
                path: '/setting/category/:id/edit',
                component: require('./views/setting/category/edit').default
            },
            {
                path: '/setting/sub-category',
                component: require('./views/setting/sub-category/index').default
            },
            {
                path: '/setting/sub-category/:id/edit',
                component: require('./views/setting/sub-category/edit').default
            },
            {
                path: '/setting/tax-rate',
                component: require('./views/setting/tax-rate/index').default
            },
            {
                path: '/setting/tax-rate/:id/edit',
                component: require('./views/setting/tax-rate/edit').default
            },
            {
                path: '/setting/gateway',
                component: require('./views/setting/gateway/index').default
            },
            {
                path: '/setting/gateway/:id/edit',
                component: require('./views/setting/gateway/edit').default
            },
            {
                path: '/setting/mda',
                component: require('./views/setting/mda/index').default
            },
            {
                path: '/setting/mda/:id/edit',
                component: require('./views/setting/mda/edit').default
            },
            {
                path: '/setting/pay-item',
                component: require('./views/setting/pay-item/index').default
            },
            {
                path: '/setting/pay-item/:id/edit',
                component: require('./views/setting/pay-item/edit').default
            },
            {
                path: '/setting/tax-office',
                component: require('./views/setting/tax-office/index').default
            },
            {
                path: '/setting/tax-office/:id/edit',
                component: require('./views/setting/tax-office/edit').default
            },
            {
                path: '/setting/organization',
                component: require('./views/setting/organization/index').default
            },
            {
                path: '/setting/organization/:id/edit',
                component: require('./views/setting/organization/edit').default
            },
            {
                path: '/setting/occupation',
                component: require('./views/setting/occupation/index').default
            },
            {
                path: '/setting/occupation/:id/edit',
                component: require('./views/setting/occupation/edit').default
            },
            {
                path: '/setting/sector',
                component: require('./views/setting/sector/index').default
            },
            {
                path: '/setting/sector/:id/edit',
                component: require('./views/setting/sector/edit').default
            },
            {
                path: '/setting/sector-line',
                component: require('./views/setting/sector-line/index').default
            },
            {
                path: '/setting/sector-line/:id/edit',
                component: require('./views/setting/sector-line/edit').default
            },
            {
                path: '/setting/business-type',
                component: require('./views/setting/business-type/index').default
            },
            {
                path: '/setting/business-type/:id/edit',
                component: require('./views/setting/business-type/edit').default
            },
            {
                path: '/setting/demand-notice-pay-item',
                component: require('./views/setting/demand-notice-pay-item/index').default
            },
            {
                path: '/setting/demand-notice-pay-item/:id/edit',
                component: require('./views/setting/demand-notice-pay-item/edit').default
            },
            {
                path: '/payment',
                component: require('./views/payment/index').default
            },
            {
                path: '/receipt',
                component: require('./views/receipt/index').default
            },
            {
                path: '/receipt/create',
                component: require('./views/receipt/create').default
            },
            {
                path: '/receipt/bulk-upload',
                component: require('./views/receipt/bulk-upload').default
            },
            {
                path: '/receipt/verify',
                component: require('./views/receipt/verify').default
            },
            {
                path: '/receipt/:id/edit',
                component: require('./views/receipt/edit').default
            },
            {
                path: '/receipt/:id',
                component: require('./views/receipt/show').default
            },
            {
                path: '/virtual-account',
                component: require('./views/virtual-account/index').default
            },
            {
                path: '/virtual-account/create',
                component: require('./views/virtual-account/create').default
            },
            {
                path: '/sweeping',
                component: require('./views/sweeping/index').default
            },
            {
                path: '/sweeping/create',
                component: require('./views/sweeping/create').default
            },
            {
                path: '/report',
                component: require('./views/report/index').default
            },
            {
                path: '/report/by-staff',
                component: require('./views/report/by-staff').default
            },
            {
                path: '/report/by-item',
                component: require('./views/report/by-item').default
            },
            {
                path: '/report/by-mda',
                component: require('./views/report/by-mda').default
            },
            {
                path: '/report/by-sector',
                component: require('./views/report/by-sector').default
            },
            {
                path: '/report/demand-notice',
                component: require('./views/report/demand-notice').default
            },
            {
                path: '/demand-notice',
                component: require('./views/demand-notice/index').default
            },
            {
                path: '/demand-notice/generate',
                component: require('./views/demand-notice/generate').default
            },
            {
                path: '/demand-notice/create',
                component: require('./views/demand-notice/create').default
            },
            {
                path: '/demand-notice/:id/edit',
                component: require('./views/demand-notice/edit').default
            },
            {
                path: '/demand-notice/:id',
                component: require('./views/demand-notice/show').default
            },
            {
                path: '/payout',
                component: require('./views/pages/payout').default
            },
            {
                path: '/paye/staff',
                component: require('./views/paye/index').default
            },
            {
                path: '/paye/paye-remitance',
                component: require('./views/paye/paye-remitance').default
            },
            {
                path: '/paye/upload',
                component: require('./views/paye/upload').default
            },
            {
                path: '/paye/:id/edit',
                component: require('./views/paye/edit').default
            },
            {
                path: '/vehicle-registration',
                component: require('./views/vehicle-registration/index').default
            },
            {
                path: '/vehicle-registration/create',
                component: require('./views/vehicle-registration/create').default
            },
            {
                path: '/vehicle-registration/:id/edit',
                component: require('./views/vehicle-registration/edit').default
            },
            {
                path: '/vehicle-registration/:id/payment',
                component: require('./views/vehicle-registration/payment').default
            },
            {
                path: '/vehicle-registration/:id',
                component: require('./views/vehicle-registration/show').default
            },
            {
                path: '/report/by-mla-user',
                component: require('./views/report/by-mla-user').default
            },
            {
                path: '/clearance',
                component: require('./views/clearance/index').default
            },
            {
                path: '/clearance/generate',
                component: require('./views/clearance/generate').default
            },
            {
                path: '/report/summary',
                component: require('./views/report/summary').default
            },
            {
                path: '/pos-transaction',
                component: require('./views/payment/pos-transaction').default
            },
            {
                path: '/marriage-certificate',
                component: require('./views/marriage-certificate/index').default
            },
            {
                path: '/marriage-certificate/create',
                component: require('./views/marriage-certificate/create').default
            },
            {
                path: '/marriage-certificate/:id/edit',
                component: require('./views/marriage-certificate/edit').default
            },
        ]
    },
    {
        path: '/',
        component: require('./layouts/default-page').default,
        meta: { validate: ['auth'] },
        children: [
            {
                path: '/profile',
                component: require('./views/pages/profile').default
            },
            {
                path: '/print-details',
                component: require('./views/pages/print-details').default
            }
        ]
    },
    {
        path: '/',
        component: require('./layouts/guest-page').default,
        meta: { validate: ['auth'] },
        children: [
            {
                path: '/auth/security',
                component: require('./views/auth/security').default,
            },
            {
                path: '/auth/lock',
                component: require('./views/auth/lock').default,
            },
        ]
    },
    {
        path: '/',                      // all the routes which can be access without authentication
        component: require('./layouts/guest-page').default,
        meta: { validate: ['guest'] },
        children: [
            {
                path: '/',
                component: require('./views/auth/login').default
            },
            {
                path: '/login',
                component: require('./views/auth/login').default
            },
            {
                path: '/password',
                component: require('./views/auth/password').default
            },
            {
                path: '/register',
                component: require('./views/auth/register').default
            },
            {
                path: '/auth/:token/activate',
                component: require('./views/auth/activate').default
            },
            {
                path: '/password/reset/:token',
                component: require('./views/auth/reset').default
            },
            {
                path: '/auth/social',
                component: require('./views/auth/social-auth').default
            },
            {
                path: '/pay-tax',
                component: require('./views/pages/pay-tax').default
            },
            {
                path: '/reset-default',
                component: require('./views/auth/reset-default').default
            },
        ]
    },
    {
        path: '/',
        component : require('./layouts/guest-page').default,
        children: [
            {
                path: '/terms-and-conditions',
                component: require('./views/pages/terms-and-conditions').default
            }
        ]
    },
    {
        path: '/',
        component : require('./layouts/error-page').default,
        children: [
            {
                path: '/terms-and-conditions',
                component: require('./views/pages/terms-and-conditions').default
            },
            {
                path: '/ip-restricted',
                component: require('./views/errors/ip-restricted').default
            },
            {
                path: '/maintenance',
                component: require('./views/errors/maintenance').default
            },
            {
                path: '/features',
                component: require('./views/pages/features').default
            }
        ]
    },
    {
        path: '*',
        component : require('./layouts/error-page').default,
        children: [
            {
                path: '*',
                component: require('./views/errors/page-not-found').default
            }
        ]
    },
];

const router = new VueRouter({
    routes,
    // linkActiveClass: 'active',
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
});

router.beforeEach((to, from, next) => {
    pageLoader = Vue.$loading.show();
    // For force logout
    // store.dispatch('resetAuthUserDetail');

    helper.check()
        .then(response => {

            // Initialize toastr notification
            helper.notification();

            // Check for IP Restriction; If restricted IP found, redirect to "/ip-restricted" route
            if(helper.getConfig('ip_filter') && localStorage.getItem('ip_restricted') && to.fullPath != '/ip-restricted') {
                pageLoader.hide();
                return next({ path: '/ip-restricted' })
            }

            // Check for Maintenance mode; If maintenance mode is on, redirect to "/maintenance" route
            if(helper.isAuth() && !helper.hasRole('admin') && helper.getConfig('maintenance_mode') && to.fullPath != '/maintenance') {
                pageLoader.hide();
                return next({ path: '/maintenance' })
            }

            if (to.matched.some(m => m.meta.validate)){
                const m = to.matched.find(m => m.meta.validate);

                // Check for authentication; If no, redirect to "/login" route
                if (m.meta.validate.indexOf('auth') > -1){
                    if(!helper.isAuth()){
                        toastr.error(i18n.auth.auth_required);
                        pageLoader.hide();
                        return next({ path: '/login' })
                    }
                }

                // Check for two factor security; If enabled, redirect to "/auth/security" route after login
                if (m.meta.validate.indexOf('two_factor') > -1){
                    if(helper.getConfig('two_factor_security') && helper.getTwoFactorCode()){
                        pageLoader.hide();
                        return next({ path: '/auth/security' })
                    }
                }

                // Check for screen lock; If enabled, redirect to "/auth/lock" route after screen lock timeout
                if (m.meta.validate.indexOf('lock_screen') > -1){
                    if(helper.getConfig('lock_screen') && helper.isScreenLocked()){
                        pageLoader.hide();
                        return next({ path: '/auth/lock' })
                    }
                }

                // Check for screen lock; If enabled, redirect to "/profile" route
                if (m.meta.validate.indexOf('complete_profile') > -1){
                    if(store.getters.getAuthUserProfileStatus == 0){
                        toastr.warning(i18n.auth.update_profile);
                        pageLoader.hide();
                        return next({ path: '/profile' })
                    }
                }

                // Check for authentication; If authenticated, redirect to "/home" route
                if (m.meta.validate.indexOf('guest') > -1){
                    if(helper.isAuth()){
                        toastr.error(i18n.auth.guest_required);
                        pageLoader.hide();
                        return next({ path: '/home' })
                    }
                }
            }

        return next()
    })
    .catch(error => {
        // Authentication check fail, redirected back to "/login" route
        store.dispatch('resetAuthUserDetail');
        pageLoader.hide();
        return next({ path: '/login' })
    });
});

router.afterEach((to, from) => {
    pageLoader.hide();
});

export default router;
